<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';    
    import SchedulerDialog from '@Quest/CorporateScenarios/Components/SchedulerDialog.vue';
    import { SchedulerDialogViewModel } from "@Quest/CorporateScenarios/Components/SchedulerDialog";

    @Component({
        components: {
            SchedulerDialog
        }
    })
    export default class ScenarioNavigation extends Vue
    {
        get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
        get strategyId() { return this.$route.params.strategyId; }
        get scenarioId() { return this.$route.params.scenarioId; }

        schedulerDialog: SchedulerDialogViewModel = new SchedulerDialogViewModel();

        getButtonClass(path: string): string
        {
            const routePrefix = `/enterprise-plan/${path}/`;
            return this.$route.path.startsWith(routePrefix) ? 'btn btn-secondary' : 'btn btn-outline-secondary';
        }
    }
</script>

<template>  
  <div>
        <SchedulerDialog :viewModel="schedulerDialog" />

        <div class="text-right align-self-end">
            <button type="button"  title="Open Scheduler (AI Assistant)"
                    class="btn btn-primary" style="padding: 0.7em 1em;" 
                    @click="schedulerDialog.show()">
                <i class="fa-solid fa-robot fa-lg mr-1"></i> Scheduler
            </button>

            <div class="btn-group" role="group">
                <a title="Portfolios" :class="getButtonClass('portfolios')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/enterprise-plan/portfolios/${workspaceId}/${strategyId}/${scenarioId}`">
                    <i class="fa-solid fa-sitemap fa-lg"></i>
                </a>
                <a title="Projects" :class="getButtonClass('projects')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/enterprise-plan/projects/${workspaceId}/${strategyId}/${scenarioId}`">
                    <i class="fa-solid fa-table fa-lg"></i>
                </a>
                <a title="Schedule" :class="getButtonClass('schedule')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/enterprise-plan/schedule/${workspaceId}/${strategyId}/${scenarioId}`">
                    <i class="fa-regular fa-calendar fa-lg"></i>
                </a>
            </div>

            <a title="Profit & Loss Report" :class="getButtonClass('pnl')" style="padding: 0.7em 2em;" v-sanitizedHref="`/#/enterprise-plan/pnl/${workspaceId}/${strategyId}/${scenarioId}`">
                P&L
            </a>
            <a title="Enterprise Plan Settings" class="btn btn-outline-secondary" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/enterprise-plan/settings/${workspaceId}/${strategyId}/${scenarioId}`">
                <i class="fa fa-lg fa-cog" aria-hidden="true"></i>
            </a>
            <a title="Back to Enterprise Plans" class="btn btn-outline-secondary" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/enterprise/planning/${workspaceId}/${strategyId}`">
                <i class="fa-solid fa-door-open fa-lg"></i>
            </a>
        </div>
    </div>
</template>